import { Theme, Typography } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import React from "react";

export const DefaultValueProps: React.FC = () => {
  const { t } = useTranslation(
    "client\\components\\categories\\DefaultValueProps",
  );

  return (
    <>
      <Typography
        component="p"
        sx={(theme: Theme) => ({
          fontSize: theme.typography.body1,
          py: theme.spacing(2),
        })}
      >
        <Typography
          component="span"
          sx={(theme: Theme) => ({
            fontSize: theme.typography.body1,
            paddingRight: theme.spacing(8),
          })}
        >
          🎥
        </Typography>
        {t("Engaging")} <b>{t("live video chat classes")}</b>
      </Typography>
      <Typography
        component="p"
        sx={(theme: Theme) => ({
          fontSize: theme.typography.body1,
          py: theme.spacing(2),
        })}
      >
        <Typography
          component="span"
          sx={(theme: Theme) => ({
            fontSize: theme.typography.body1,
            paddingRight: theme.spacing(8),
          })}
        >
          🏅
        </Typography>
        <b>{t("Vetted and passionate")}</b> {t("teachers")}
      </Typography>
      <Typography
        component="p"
        sx={(theme: Theme) => ({
          fontSize: theme.typography.body1,
          py: theme.spacing(2),
        })}
      >
        <Typography
          component="span"
          sx={(theme: Theme) => ({
            fontSize: theme.typography.body1,
            paddingRight: theme.spacing(8),
          })}
        >
          🚀
        </Typography>
        {t("Build")} <b>{t("confidence through progress")}</b>
      </Typography>
    </>
  );
};
